export const MAX_NEXT_OF_KIN_PRIORITY = 10;
export const MIN_NEXT_OF_KIN_PRIORITY = 1;